import { defineMessages } from 'react-intl';

export default defineMessages({
  reportHistoryTitle: {
    id: 'App.RentForecast.ReportHistory.Title',
    defaultMessage: 'Report History',
  },
  reportHistoryTableEmpty: {
    id: 'App.RentForecast.ReportHistory.Table.Empty',
    defaultMessage:
      'There are no generated reports found for the current rent forecast',
  },
  reportHistoryHeaderReport: {
    id: 'App.RentForecast.ReportHistory.Table.Header.Report',
    defaultMessage: 'Report',
  },
  reportHistoryHeaderSource: {
    id: 'App.RentForecast.ReportHistory.Table.Header.Source',
    defaultMessage: 'Source',
  },
  reportHistoryHeaderDate: {
    id: 'App.RentForecast.ReportHistory.Table.Header.Date',
    defaultMessage: 'Date',
  },
  reportHistoryHeaderTime: {
    id: 'App.RentForecast.ReportHistory.Table.Header.Time',
    defaultMessage: 'Time',
  },
  reportHistoryHeaderDownload: {
    id: 'App.RentForecast.ReportHistory.Table.Header.Download',
    defaultMessage: 'Download',
  },
});
